import { LIKERT_DIMENSION_EMPTY_FALLBACK } from '@/helpers/assessmentDimensionScore';

/**
 * Clamp a Likert boxplot stat to the valid 1–5 range (0 is legacy empty-dimension sentinel).
 * @param {number} value
 * @returns {number}
 */
export function clampLikertBoxplotStat(value) {
  return Math.max(LIKERT_DIMENSION_EMPTY_FALLBACK, Math.min(5, Number(value)));
}

/**
 * chartjs-chart-boxplot recomputes whiskers with Tukey IQR (coef 1.5) unless whiskerMin/Max are set.
 * Use this so drawn whiskers match tooltip min/max on pre-aggregated stats.
 *
 * @param {object} stats
 * @returns {object}
 */
export function withBoxplotExactWhiskers(stats) {
  if (!stats || typeof stats !== 'object') return stats;
  return {
    ...stats,
    whiskerMin: stats.min,
    whiskerMax: stats.max,
  };
}
